import { QueryClient } from '@tanstack/react-query'

// Create a singleton QueryClient instance that can be imported anywhere
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000*1000, // 5 minutes - data is fresh for 5 minutes
      gcTime: 10 * 60 * 1000*1000, // 10 minutes - keep unused data in cache for 10 minutes
      refetchOnWindowFocus: true, // Refetch on window focus for better data freshness
      retry: 3, // Retry up to 3 times on failure
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff with max 30s
      networkMode: 'always', // Only retry when online
      refetchOnMount: true, // Always refetch when component mounts
      refetchOnReconnect: true, // Refetch when reconnecting to network
    },
    mutations: {
      networkMode: 'always', // Always try to mutate even if offline
      retry: 2, // Retry mutations twice on failure
    },
  },
})
